/*
 * Copyright (c) 2017 Datarista, Inc.
 */

import { Map, List, Record } from 'immutable';
import { actionTypes } from '../actions/order';

export const Order = new Record(
  {
    order: {
      id: 0,
      accountId: 0,
      company: {
        id: null,
        name: '',
        alias: '',
        code: null,
        addressLine1: '',
        addressLine2: '',
        city: '',
        state: '',
        country: '',
        zipCode: '',
        phone: '',
      },
      person: {
        id: null,
        title: '',
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
      },
      previousOrderId: 0,
      providerOrderNumber: '',
      providerCustomerNumber: '',
      autoRenew: false,
      status: '',
      numberOfSeats: 0,
      pricePerSeatPerMonth: 0,
      recordAmount: 0,
      recordCredits: 0,
      estimatedPriceTotal: 0,
      currency: '',
      isBillable: true,
      contactMatchByAccount: true,
      csvDownloadEnabled: false,
      leadMatchEnabled: false,
      useEndUserCredentials: false,
      billingInfo: '',
      matchedPairsProvided: '',
      startDate: '',
      endDate: '',
      createdBy: 0,
      createdByFirstName: '',
      createdByLastName: '',
      createdOn: '',
      updatedBy: 0,
      updatedOn: '',
    },
    platformUseCases: [
      {
        id: 0,
        platform: {
          id: 0,
          description: '',
          code: '',
          platformType: '',
        },
        useCase: {
          code: '',
          description: '',
        },
      },
    ],
    listSKUs: [
      {
        dataSet: {
          id: 0,
          accountId: 0,
          providerDataSetNum: '',
          name: '',
          listType: '',
          listGeo: '',
          status: 0,
          code: '',
          s3Path: '',
          searchHost: '',
          customType: '',
          incrementalUpdates: false,
          autoVersionUpdates: false,
          createdBy: 0,
          createdOn: '',
          updatedBy: 0,
          updatedOn: '',
        },
        fieldSet: {
          id: 0,
          datasetId: 0,
          accountId: 0,
          name: '',
          setType: 0,
          description: '',
          sku: '',
          status: 0,
          isCustom: false,
          createdBy: 0,
          createdOn: '',
          updatedBy: 0,
          updatedOn: '',
          fieldCount: 0,
          orderCount: 0,
          installedCount: 0,
        },
      },
    ],
    creditsRemaining: 0,
    savedSearches: [],
  },
  'Order'
);

const Install = new Record({
  id: 0,
  orderId: 0,
  description: '',
  installStatus: '',
  installKey: '',
  processingStatus: '',
  installDate: '',
  createdOn: '',
  updatedOn: '',
  crmAuthId: 0,
  customConfiguration: {
    contactMatchByAccount: true,
    csvDownloadEnabled: false,
    leadMatchEnabled: false,
    useEndUserCredentials: false,
  },
});

const orderList = new Map({
  orders: new List(),
  platformMap: new Map(),
  useCaseMap: new Map(),
  currentOrder: new Map(),
  install: new Install(),
});

const initialState = orderList;

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.ORDER_FETCH_ALL_SUCCESS: {
      const newOrdersArray = action.orders.map(order => new Order(order));
      const newOrdersList = new List(newOrdersArray);
      return state.merge({ orders: newOrdersList });
    }
    case actionTypes.PLATFORM_CASE_SUCCESS: {
      return state.merge({
        platformMap: action.platformMap,
        useCaseMap: action.useCaseMap,
      });
    }
    case actionTypes.ORDER_FETCH_BY_ID_SUCCESS: {
      const newOrder = new Order(action.order);
      return state.merge({ currentOrder: newOrder });
    }
    case actionTypes.RECEIVE_INSTALL_STATUS_SUCCESS: {
      const install = new Install(action.install);
      return state.merge({ install });
    }
    default: {
      return state;
    }
  }
}
